/**
 * Magma pseudo box shared constants
 */
export const MAGMA_PSEUDO_VIEWBOX = '0 0 307 102';
